import { useTheme } from 'styled-components/macro';
import { resolveMessage } from './field-message.utils';
import { FieldMessageProps } from './field-message.types';
import { messageIcon } from './field-message.constants';
import { IconBox, Root } from './field-message.styled';
import { InlineSpinner } from '../../loaders/inline-spinner/inline-spinner';
import { sizeConfig } from '../_core/field';
import { Text } from '../text';

/**
 * Подпись под полем ввода. Принимает все сообщения сразу и показывает одно.
 *
 * Без `status` сообщение выбирается по приоритету: pending, ошибка,
 * предупреждение, успех, подсказка. Форма отдаёт тексты, какие у неё есть,
 * и не решает, какой из них сейчас актуален: при появлении ошибки подсказка
 * сама уходит, при исчезновении — возвращается. Так удобно формам, где
 * ошибка приходит готовой строкой, например из react-hook-form.
 *
 * С `status` показывается текст заданного состояния. Так удобно полям с
 * собственным состоянием: тексты перечисляются один раз, без условия вокруг
 * каждого. Пока идёт проверка, прошлый вердикт не показываем в обоих
 * случаях: он уже не про то значение, которое в поле.
 */
export const FieldMessage = (props: FieldMessageProps) => {
  const { size = 's', id, className } = props;

  const theme = useTheme();

  const resolved = resolveMessage(props);

  if (!resolved) {
    return null;
  }

  const { status, message, isPending } = resolved;
  const MessageIcon = messageIcon[status ?? 'hint'];

  return (
    <Root
      id={id}
      className={className}
      $status={status}
      role={status === 'error' ? 'alert' : undefined}
    >
      <IconBox $size={size}>
        {isPending ? (
          <InlineSpinner aria-hidden />
        ) : (
          <MessageIcon aria-hidden />
        )}
      </IconBox>

      <Text variant={sizeConfig(theme)[size].textVariant}>{message}</Text>
    </Root>
  );
};
